import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=0d9f237e&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
import style0 from "./Projects.vue?vue&type=style&index=0&id=0d9f237e&prod&lang=scss&scoped=true"
import style1 from "./Projects.vue?vue&type=style&index=1&id=0d9f237e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f237e",
  null
  
)

export default component.exports